import React from "react";

/**
 * Beaudesert General Practice custom logo
 * - Red ECG heartbeat line + green medical cross mark
 * - Bold, larger clinic name (no phone number)
 *
 * Props:
 *   variant: "dark" (default, for light backgrounds) | "light" (for dark backgrounds)
 *   size:    "sm" | "md" | "lg"    (default "md")
 */
export default function Logo({ variant = "dark", size = "md" }) {
  const titleColor = variant === "light" ? "#ffffff" : "#1a2464";
  const subColor = variant === "light" ? "rgba(255,255,255,0.75)" : "#4a4a63";

  const sizes = {
    sm: { mark: "h-8 w-8", title: "text-[16px] md:text-[17px]", sub: "text-[10px] md:text-[11px]" },
    md: { mark: "h-10 w-10 md:h-11 md:w-11", title: "text-[18px] md:text-[20px]", sub: "text-[11px] md:text-[12px]" },
    lg: { mark: "h-12 w-12 md:h-14 md:w-14", title: "text-[22px] md:text-[26px]", sub: "text-[12px] md:text-[13px]" },
  };
  const s = sizes[size] || sizes.md;

  return (
    <div className="flex items-center gap-3 shrink-0">
      <LogoMark className={s.mark} />
      <div className="leading-tight">
        <div
          className={`font-extrabold tracking-tight ${s.title}`}
          style={{ color: titleColor, letterSpacing: "-0.01em" }}
        >
          Beaudesert General Practice
        </div>
        <div
          className={`font-semibold tracking-[0.02em] mt-0.5 ${s.sub}`}
          style={{ color: subColor }}
        >
          & Skin Cancer Clinic
        </div>
      </div>
    </div>
  );
}

function LogoMark({ className = "h-11 w-11" }) {
  return (
    <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
      {/* Red heartbeat / ECG line background */}
      <path
        d="M2 34 H14 L18 24 L22 44 L26 30 H34"
        stroke="#e11d48"
        strokeWidth="3.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      {/* Green medical cross */}
      <g transform="translate(32,32)">
        <rect x="-16" y="-16" width="32" height="32" rx="6" fill="#16a34a" />
        <rect x="-3.5" y="-11" width="7" height="22" rx="1.5" fill="#ffffff" />
        <rect x="-11" y="-3.5" width="22" height="7" rx="1.5" fill="#ffffff" />
      </g>
    </svg>
  );
}
